export default __webpack_public_path__ + "static/media/NeueMontreal-LightItalic.7979a893.woff2";